// extracted by mini-css-extract-plugin
var _1 = "TopicPrivacyIcon-module__iconContainer--UBWsU";
var _2 = "TopicPrivacyIcon-module__large--qy7HC";
var _3 = "TopicPrivacyIcon-module__medium--LkD_p";
var _4 = "TopicPrivacyIcon-module__regular--jsX6x";
var _5 = "TopicPrivacyIcon-module__small--oWTwc";
export { _1 as "iconContainer", _2 as "large", _3 as "medium", _4 as "regular", _5 as "small" }
